import HospitalAdminCTA from './HospitalAdminCTA';

export default HospitalAdminCTA;
